import "./assets/styles/master.scss";
import "./assets/iconfont";
import App from "./App.vue";
import { createApp } from "./starter";
import { initRouter } from "./router";
import { initHttpClient } from "./http";
import { initWindow } from "@/services/window";
import { initI18n } from "@/services/i18n";
import { initStore } from "./store";

createApp(App)
  .use(initStore)
  .use(initRouter)
  .use(initHttpClient)
  .next(initI18n)
  .next(initWindow)
  .mount("#app");
